import React,{Component} from 'react';
import { WithStyles, withStyles, Box, Typography, Grid, IconButton } from '@material-ui/core';
import { ChatMobileStyles } from '../../styles';
import { EnviarMensaje,ListaGestionGuia,Alerta,MensajeMovil } from '../atoms';
import { ArrowBack,MoreVert } from '@material-ui/icons';
import { IMensaje,IGuia } from '../../interface';
import { connect } from 'react-redux';
import { fechaOrganizada , fechaOrganizadaAlert} from '../../functions/index';
import { RouteComponentProps } from 'react-router-dom';


type ChatMobileState = {dropdown:boolean,cerrar:boolean, open:boolean}
interface ChatMobileProp extends WithStyles<typeof ChatMobileStyles>,RouteComponentProps {
    handleClose: ()=>void;
    children?: React.ReactNode;
    mensajes:IMensaje[];
    guia:IGuia;
    className?: string;
  }
export class ChatMobileComponent extends Component<ChatMobileProp, ChatMobileState>{

    constructor(props:ChatMobileProp) {
        super(props);
        this.state = {
            dropdown: false,
            cerrar: false,
            open: false,
        };
        this.handleClick = this.handleClick.bind(this);
        this.goBack = this.goBack.bind(this);
        this.handleCerrar = this.handleCerrar.bind(this);
        this.handClose = this.handClose.bind(this);
    }

    handClose(){
        this.setState({open: false})
    }

    handleClick(){
        this.setState({dropdown: !this.state.dropdown})
    }
    handleCerrar(){
        this.setState({dropdown: false})
    }
    componentDidMount(){
        !this.props.mensajes.length && this.goBack();
        const element = document.getElementById("boxMensajes");
        if(element) element.scrollTop = element.scrollHeight
        window.addEventListener('resize', () => {
            // We execute the same script as before
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });
    }

    componentDidUpdate(){
        const element = document.getElementById("boxMensajes");
        if(element) element.scrollTop = element.scrollHeight
    }
    goBack(){
        this.props.history.goBack();
    }

    render(){
        const mensajes = this.props?.mensajes?.map(m => {
            m.Nombre=m.Nombre ? m.Nombre : this.props.guia.nombre_destinatario
            return m
          });

        let horaNueva:string='';
        if(mensajes.length){
            if (this.props.guia.fecha_inicio){
                const ultimoHora = fechaOrganizadaAlert(this.props.guia.fecha_inicio.toDate().toString());
                horaNueva = `${ultimoHora}`
            }
        }
        const classes = this.props.classes;
        // const vh = window.innerHeight * 0.01;
        // const h = `calc(var(${vh}, 1vh) * 100)`;
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        return (
                <Box className={classes["box-container"]} bgcolor="#FFFFFF" display="flex" flexDirection="column">
                    <Grid container className={classes.grid}>
                        <Grid item xs={1} className={classes['grid-icon-back']}>
                            <IconButton edge="end" className={classes.iconbutton} onClick={this.goBack}>
                                <ArrowBack color="inherit" fontSize="large"/>
                            </IconButton>
                        </Grid>
                        <Grid item xs={10} className={classes['grid-guia']}>
                            <Box fontSize={20}>
                                Guía: {this.props.guia.guia}
                            </Box>
                            <Box fontSize={16}>
                                Destinatario: {this.props.guia.nombre_destinatario}
                            </Box>
                        </Grid>
                        <Grid  item xs={1} className={classes['grid-icon-more']}>
                            <IconButton edge="end" className={classes.iconbutton} onClick={() => this.handleClick()}>
                                <MoreVert color="inherit" fontSize="large"/>
                            </IconButton>
                            { this.state.dropdown && <ListaGestionGuia handleCerrar={this.handleCerrar} /> }
                        </Grid>
                    </Grid>   
                    <Box bgcolor='#FFFFFF'>
                    <Grid container spacing={1} direction="column" justify="flex-start">
                            <Grid item xs={12}>
                                <Box m={1} >
                                    <Typography align="center">
                                        <Box fontSize={15}>Chat iniciado {horaNueva}</Box>
                                    </Typography>
                                </Box>              
                            </Grid>
                        </Grid>

                    </Box>
                    <Box id="boxMensajes" bgcolor="#FFFFFF" className={classes["box-mensajes"]}>
                          
                        <Box>
                        <Grid container spacing={1}  justify="flex-start">
                            {

                            mensajes.length ? mensajes.map((m:IMensaje) => {

                                m.Mobile=true;
                                return (
                                <Grid  item xs={12}>
                                    {                      
                                        
                                        <Box marginRight={1}  marginLeft={1}>
                                           <MensajeMovil guia={this.props.guia} open={this.state.open} handClose={this.handClose}  mensaje={m} />
                                        </Box>        
                                    }

                                                                     
                                </Grid>
                                )
                            }
                            ) : ""
                            }
                            
                        </Grid>

                        </Box>  
                        
                    </Box>

               
                    <Box className={classes.enviarmensaje}>
                    
                        <EnviarMensaje guia={this.props.guia} mobile={true}/>
                    </Box>
                    
                </Box>
        )
    }

}

const mapStateToProps = (state:any) => {
    return {
      mensajes: state.mensajesReducer,
      guia: state.guiasReducer
    }
  }
  
const mapDispatchToProps = () => ({})
  
  
export const ChatMobile = withStyles(ChatMobileStyles)(connect(mapStateToProps,mapDispatchToProps)(ChatMobileComponent))